export const removeSessionStorage = (key: string) => {
  return sessionStorage.removeItem(key);
};
